import { View } from 'react-native';
const BottomTabs = View;
export default BottomTabs;
//# sourceMappingURL=BottomTabs.web.js.map